import { addReviewWindow, successSend } from "../reviews/allinone-write-review";
import { insertSlide } from "../reviews/slide-write-review";
import { requests } from "./network";
import reviewsNodes from "./node";
import v from "./variable";

// Start
/**
 * ## 嵌入写评论弹窗
 * @param {Number} rating - 评分
 * @param {Number} size - 星星大小，单位px
 * @param {Number} type - 类型，1 字体文件星星图标，2 幻灯片星星图标（黑白），3 产品页、集合页评价星星图标
 * @param {Boolean} isCarouselProSelector - 轮播是否嵌入产品选择器
 */
// ## 设置写评论控件
async function setWriteReview() {
	let writePopupType = 1;
	const allinoneType = 1;
	const nodeColl = reviewsNodes.write;
	//俩个弹窗
	if (!v.writePopupEmbedded) {
		v.writePopupEmbedded = true;
		const requestPromise = [];
		if (typeof vstar_write_review_settings !== "undefined" && !v.isSettingUpdate) {
			requestPromise.push([null, vstar_write_review_settings]);
		} else {
			requestPromise.push(requests.getWriteRevSetting());
		}

		if (v.productId) {
			requestPromise.push(requests.getAttribute());
		} else {
			requestPromise.push(Promise.resolve([null, v.lang]));
		}
		let isRequestLang = false;
		if (Object.keys(v.lang).length === 0) {
			isRequestLang = true;
			requestPromise.push(requests.getLang());
		} else {
			requestPromise.push(Promise.resolve([null, v.lang]));
		}
		const [settingsReq, attrReq, langReq] = await Promise.all(requestPromise);

		const error = settingsReq[0];
		if (error) {
			return;
		}
		const data = settingsReq[1];

		if (v.productId) {
			v.attributeConfig = attrReq[1];
		}

		let lang = langReq[1];

		if (isRequestLang) {
			lang = JSON.parse(langReq[1].lang_json);
		}
		v.lang = lang;

		// const data = await getWriteReviewSetting();
		const form = data.write_review_form;
		writePopupType = form;
		v.writeRestriction = data.leave_review_method;
		v.writeForm = form;
		if (form === 1) {
			addReviewWindow(data);
			successSend(data);
		} else if (form === 2) {
			insertSlide(data);
		}

		if (v.userSetting.is_qa_active === 1 && writePopupType !== allinoneType) {
			addReviewWindow(data);
			successSend(data);
		}

		const container = $dqs(".trustoo-write-review");
		nodeColl.container = container;
		if (form === 1 || v.userSetting.is_qa_active === 1) {
			const allInOne = $dqs("#trustoo-allinone");
			nodeColl.allInOne = allInOne;
			nodeColl.image = $dqs(".product-image", allInOne);
			nodeColl.prodName = $dqs(".product-right", allInOne);
			nodeColl.title = $dqs(".head-title", allInOne);
			nodeColl.contentLabel = $dqs(".feedback-area>.tt-input-title", allInOne);
			nodeColl.content = $dqs(".big-input", allInOne);
			nodeColl.submit = $dqs(".form-submit", allInOne);
		}

		if (data.show_review_btn === 1) {
			v.writeTo.type = data.write_review_type;
			const writeBtn = reviewsNodes[v.reviewsKey].writeBtn;
			if (data.write_review_type === "shop" && v.isMixReview && writeBtn) {
				writeBtn.textContent = v.lang.store_review.write_btn_text;
			}
			v.globalStyle.textContent += `.trustoo-widget .tt-write-reviews {display: block !important;}`;
		}

		return settingsReq;
	}

	// if (isInsertProdSelector) {
	// 	window.TrustooReviews.carousel.writeProductReviewType;
	// 	{
	// 		// showProductSelector();
	// 	}
	// }
}

/**
 * ## 构造星星SVG
 * @param {Number} rating - 评分
 * @param {Number} size - 星星大小，单位px
 * @param {Number} type - 类型，1 字体文件星星图标，2 幻灯片星星图标（黑白），3 产品页、集合页评价星星图标
 * @param {Boolean} isHasHalf - 是否存在半星
 */
function getTotalStarString(rating, isHasHalf = false) {
	const { isProPage } = v;
	const icon = v.ratingIconSvg;
	let extraCls = "";
	if (!icon) {
		extraCls = " pending";
	}
	const starString = `<div class="star-item${extraCls}">${icon}</div>`;
	const nostarString = `<div class="star-item nostar${extraCls}">${icon}</div>`;

	if (!parseInt(rating)) rating = 0;
	var starTag = "";
	var starNum = Math.floor(rating);
	for (var i = 0; i < starNum; i++) {
		starTag += starString;
	}
	if (starNum < rating && isHasHalf) {
		if (isProPage) v.isProHasHalfStar = true;
		const percentage = ((rating - starNum) * 100).toFixed(2);
		starNum++;
		starTag += `<div class="star-item half-star">
		<div class="item-nostar${extraCls}">${icon}</div>
    <div class="item-star${extraCls}" style="width:${iconShowRatioAdjustment(percentage)}%">
      ${icon}
    </div>
  </div> `;
	}

	for (var i = 0; i < 5 - starNum; i++) {
		starTag += nostarString;
	}

	return starTag;
}

/**
 * ## 调整评分图标显示比例
 * @param {Number} percentage - 比例值
 */
function iconShowRatioAdjustment(percentage) {
	let temp = parseInt(percentage) / 100;
	const ratio = parseInt(percentage) / 100;
	switch (v.userSetting.rating_icon_type) {
		case 13: {
			temp = 0.28 + parseFloat((0.44 * ratio).toFixed(2));
			break;
		}
		case 15: {
			temp = 0.215 + parseFloat((0.57 * ratio).toFixed(2));
			break;
		}
	}
	temp = temp * 100;
	return temp;
}

/**
 * ## 上传记录的数据
 * @param {String} type - 触发记录的类型 reviews_click、add_to_cart、reviews_view
 * @param {String} cartToken - 购物车token
 * @param {Boolean} isCart - 本次记录是不是购物车加购记录
 */
function processRecordedData(type, cartToken = "", isCart) {
	if (v.isProPage && v.ratingData && v.ratingData.rating == 0) {
		return;
	}
	let clientId = "";
	let uv = 0;
	if (localStorage.getItem("trustoo_uv")) {
		clientId = localStorage.getItem("trustoo_uv");
	} else {
		clientId = v.shop_id + "_" + new Date().getTime();
		localStorage.setItem("trustoo_uv", clientId);
		uv = 1;
	}
	// 存储这次pv触发的产品的id，如果购物车跳转，buy now跳转可以补发记录
	if (v.isProPage) {
		gsSession("set", "tt_pv_product_id", v.productId);
		gsSession("set", "tt_cart_product_id", v.productId);
	}

	if (!v.isRecordPV || (isCart && !v.isRecordCart)) {
		v.isRecordPV = true;
		const p = {
			client_id: clientId,
			event_category: type
		};
		if (["reviews_click", "reviews_view"].includes(type)) {
			p.unique_visitor = uv;
		}
		if (v.productId) {
			p.product_id = v.productId;
		}
		if (cartToken) {
			p.cart_token = cartToken;
			v.isRecordCart = true;
		} else if (v.cartWatcher) {
			const token = v.cartWatcher.storedCartToken().split("?key=")[0];
			p.cart_token = token;
		}

		requests.recordInfo(p).then(() => {
			// 已记录pv，清除信息
			if (isCart) {
				gsSession("set", "tt_cart_product_id", null);
			}
		});
	}
}

// 获取时间戳
function getTimeStamp() {
	return new Date().getTime();
}
// 颜色转换
function hexToRgba(hex, opacity) {
	if (opacity == 2) {
		opacity = 1;
	}
	return (
		"rgba(" +
		parseInt("0x" + hex.slice(1, 3)) +
		"," +
		parseInt("0x" + hex.slice(3, 5)) +
		"," +
		parseInt("0x" + hex.slice(5, 7)) +
		"," +
		opacity +
		")"
	);
}

// 添加toast
function setToast(msg, top = "10%", left = "50%") {
	var dom = document.createElement("div");
	dom.className = "tt-toast";
	dom.style.cssText = `left:${left};top:${top}`;
	dom.innerHTML = msg;
	document.body.appendChild(dom);
	setTimeout(() => {
		document.querySelector(".tt-toast").remove();
	}, 1500);
}
// 发布评论，按钮添加loading
function setLoading(dom, size = 20) {
	var loading = document.createElement("div");
	loading.className = "loader";
	loading.style.cssText = `display: inline-block;width:${size}px;height:${size}px`;
	dom.appendChild(loading);
}

//=======================================工具函数=========================================
//base64压缩
//Mark上传图片压缩
function dealImage(base, dom, res) {
	let image = new Image(); //设置一个image
	image.src = base; //动态加载
	image.onload = function () {
		let canvas = document.createElement("canvas"), //创建一个canvas元素
			context = canvas.getContext("2d"),
			originWidth = image.width /* 图片的宽度 */,
			originHeight = image.height /* 图片的高度 */,
			data = ""; //存储压缩后的图片
		if (originWidth < originHeight) {
			dom.style.backgroundSize = "auto 100%";
		}
		const quality = 0.8;
		// 设置最大尺寸限制，将所有图片都压缩到小于1m
		const maxWidth = 1200,
			maxHeight = 1200;
		// 需要压缩的目标尺寸
		let targetWidth = originWidth,
			targetHeight = originHeight;
		// 等比例计算超过最大限制时缩放后的图片尺寸
		if (originWidth > maxWidth || originHeight > maxHeight) {
			if (originWidth / originHeight > 1) {
				// 宽图片
				targetWidth = maxWidth;
				targetHeight = Math.round(maxWidth * (originHeight / originWidth));
			} else {
				// 高图片
				targetHeight = maxHeight;
				targetWidth = Math.round(maxHeight * (originWidth / originHeight));
			}
		}
		canvas.width = targetWidth;
		canvas.height = targetHeight; //设置绘图的高度
		context.drawImage(image, 0, 0, targetWidth, targetHeight);
		//使用toDataURL将canvas上的图片转换为base64格式
		data = canvas.toDataURL("image/jpg", quality);
		dom.style.backgroundImage = `url(${data})`;
		res(data);
	};
}

async function compressImage(file) {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = () => {
			try {
				const canvas = document.createElement("canvas");
				const ctx = canvas.getContext("2d");

				// 计算新尺寸
				const maxSize = 2000;
				let { width, height } = img;

				if (width < 2000 && height < 2000) {
					resolve(file);
					return;
				}

				if (width > height) {
					if (width > maxSize) {
						height = (height * maxSize) / width;
						width = maxSize;
					}
				} else {
					if (height > maxSize) {
						width = (width * maxSize) / height;
						height = maxSize;
					}
				}

				canvas.width = width;
				canvas.height = height;

				// 绘制图片
				if (file.type === "image/jpeg") {
					ctx.fillStyle = "white";
					ctx.fillRect(0, 0, width, height);
				}
				ctx.drawImage(img, 0, 0, width, height);

				canvas.toBlob((blob) => {
					if (!blob) {
						reject(new Error("图片压缩失败"));
						return;
					}

					// 创建新的File对象，使用原图格式
					const compressedFile = new File([blob], file.name, {
						type: file.type,
						lastModified: Date.now()
					});

					resolve(compressedFile);
				}, file.type);
			} catch (error) {
				reject(error);
			}
		};
		img.onerror = reject;
		img.src = URL.createObjectURL(file);
	});
}

//返回窗口宽度
function getWindowWidth() {
	return window.innerWidth;
}

//Mark图片预加载
// var preLoadCount = 0,
function imgLoadLimit(urlArr, limit) {
	const urlArrCy = [...urlArr];

	if (urlArrCy.length <= limit) {
		const promiseArr = urlArrCy.map((url) => {
			var pro = imgLoad(url);
			pro.id = url;
			return pro;
		});
		return Promise.all(promiseArr);
	}

	const promiseArr = urlArrCy.splice(0, limit).map((url) => {
		var pro = imgLoad(url);
		pro.url = url;
		return pro;
	});
	urlArrCy
		.reduce(
			(prePromise, curUrl) =>
				prePromise
					.then(() => Promise.race(promiseArr))
					.then((resUrl) => {
						let promiseIndex = promiseArr.findIndex((item) => item.url == resUrl);
						promiseArr.splice(promiseIndex, 1);
						var pro = imgLoad(curUrl);
						pro.url = curUrl;
						promiseArr.push(pro);
					}),
			Promise.resolve()
		)
		.then(() => Promise.all(promiseArr));
}

// 图片上传
function imgLoad(url) {
	return new Promise((res, rej) => {
		var img = new Image();
		img.url = url;
		img.onerror = () => {
			rej();
			//   console.log(img.id,'图片加载失败');
		};
		img.onload = () => {
			//   console.log(img.id, '图片加载成功');
			res(img);
		};
		img.src = url;
	});
}

function getObjectURL(file) {
	var url = null;
	// 下面函数执行的效果是一样的，只是需要针对不同的浏览器执行不同的 js 函数而已
	if (window.createObjectURL != undefined) {
		// basic
		url = window.createObjectURL(file);
	} else if (window.URL != undefined) {
		// mozilla(firefox)
		url = window.URL.createObjectURL(file);
	} else if (window.webkitURL != undefined) {
		// webkit or chrome
		url = window.webkitURL.createObjectURL(file);
	}
	return url;
}

function setObserve(node, config, callback, v) {
	// 选择需要观察变动的节点
	// const node = document.body

	// 观察器的配置（需要观察什么变动）
	// const config = { attributes: true, childList: true, subtree: true, characterData: true };
	// 当观察到变动时执行的回调函数
	// const callback = function (mutationsList, observer) {
	// };

	// 创建一个观察器实例并传入回调函数
	v.observer = new MutationObserver(callback);

	// 以上述配置开始观察目标节点
	v.observer.observe(node, config);
}

//锚点跳转
function scrollTo(node, mode = "smooth") {
	node.scrollIntoView({
		behavior: mode,
		block: "start"
	});
}
// 获取手机系统
function getMobileSystem() {
	var u = navigator.userAgent;
	var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
	var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
	if (isAndroid) {
		return "android";
	}
	if (isiOS) {
		return "ios";
	}
}

/**
 * document.querySelector
 * @param {number} selector css选择器
 * @param {HTMLElement} context 上下文
 * @returns {HTMLElement} 选中的单个元素
 */
function $dqs(selector, context) {
	let node;
	if (context) {
		node = context.querySelector(selector);
	} else {
		node = document.querySelector(selector);
	}
	return node;
}

/**
 * document.querySelectorAll
 * @param {number} selector css选择器
 * @param {HTMLElement} context 上下文
 * @returns {HTMLElement} 选中元素集合
 */
function $dqsa(selector, context) {
	let nodes;
	if (context) {
		nodes = context.querySelectorAll(selector);
	} else {
		nodes = document.querySelectorAll(selector);
	}
	return nodes;
}
//是否为移动端 返回布尔值
// function isMobile() {
//   return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) ? true : false
// }

/**
 * 复制到剪切板
 * @param {string} text 字符串
 * @param {function} callback 成功回调函数
 */
function copyToClipboard(text, callback) {
	navigator.clipboard.writeText(text).then(() => {
		callback();
	});
}

function isMobile() {
	let ua = navigator.userAgent,
		isAndroid = /(?:Android)/.test(ua),
		isFireFox = /(?:Firefox)/.test(ua),
		isTablet =
			/(?:iPad|PlayBook)/.test(ua) ||
			(isAndroid && !/(?:Mobile)/.test(ua)) ||
			(isFireFox && /(?:Tablet)/.test(ua)),
		isPhone = /(?:iPhone)/.test(ua) && !isTablet;
	return isAndroid || isPhone;
}

// 防抖
function debounce(fn, delay) {
	var timeout = null;
	return function (...args) {
		if (timeout) {
			clearTimeout(timeout);
		}

		timeout = setTimeout(() => {
			fn(...args);
		}, delay);
	};
}

function setCopy(node) {
	// var copyDOM = $dqs('#discount .body-code')  //需要复制文字的节点
	var range = document.createRange(); //创建一个range
	window.getSelection().removeAllRanges();
	range.selectNode(node); // 选中需要复制的节点
	window.getSelection().addRange(range); // 执行选中元素
	var successful = document.execCommand("copy"); // 执行 copy 操作
	if (successful) {
		setToast("Copy successfully");
	} else {
	}
	// 移除选中的元素
	window.getSelection().removeAllRanges();
}

// promise延时
function setDelay(delay) {
	return new Promise((res) => {
		setTimeout(() => {
			res();
		}, delay);
	});
}

function gsSession(method, name, data) {
	if (method === "set") {
		try {
			sessionStorage.setItem(name, JSON.stringify(data));
		} catch (error) {}
	} else {
		return JSON.parse(sessionStorage.getItem(name));
	}
}
function gsLocal(method, name, data) {
	if (method === "set") {
		localStorage.setItem(name, JSON.stringify(data));
	} else {
		return JSON.parse(localStorage.getItem(name));
	}
}

// 获取ip
function returnCitySN(v) {
	fetch("https://www.cloudflare.com/cdn-cgi/trace")
		.then((res) => {
			return res.text();
		})
		.then((data) => {
			data = data.split("\n");
			v.ip = data[2].split("=")[1];
			v.loc = data[9].split("=")[1];
		});
}

//图片上传
function get_suffix(filename) {
	let pos = filename.lastIndexOf(".");
	let suffix = "";
	if (pos != -1) {
		suffix = filename.substring(pos);
	}
	let g_object_name = random_string(10) + suffix;
	return g_object_name;
}
// iso随机数生成
function random_string(len) {
	len = len || 32;
	var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
	var maxPos = chars.length;
	var pwd = "";
	for (var i = 0; i < len; i++) {
		pwd += chars.charAt(Math.floor(Math.random() * maxPos));
	}
	return pwd;
}

// 浏览器是否支持支持Web
function isWebPSupported() {
	return new Promise((resolve) => {
		const webpImage = new Image();

		// 图片加载成功表示支持WebP
		webpImage.onload = function () {
			resolve(webpImage.width === 1);
		};

		// 图片加载失败表示不支持WebP
		webpImage.onerror = function () {
			resolve(false);
		};

		// 一个1x1像素的WebP测试图片（Base64编码）
		webpImage.src =
			"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=";
	});
}
// End

export {
	getTotalStarString,
	processRecordedData,
	getTimeStamp,
	hexToRgba,
	setToast,
	setLoading,
	dealImage,
	getWindowWidth,
	imgLoadLimit,
	imgLoad,
	scrollTo,
	$dqs,
	$dqsa,
	isMobile,
	debounce,
	returnCitySN,
	getMobileSystem,
	setObserve,
	gsSession,
	gsLocal,
	setDelay,
	get_suffix,
	setCopy,
	getObjectURL,
	isWebPSupported,
	copyToClipboard,
	compressImage,
	setWriteReview
};
